var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.editedDelegation != null
        ? _c("template-list", {
            attrs: { "document-type": 1, value: _vm.editedDelegation },
            on: {
              "update:value": function($event) {
                _vm.editedDelegation = $event
              }
            }
          })
        : _vm._e(),
      _c("v-container", [
        _c("h1", [_vm._v(_vm._s(_vm.$t("delegation.form.newSettlement")))]),
        _c(
          "div",
          { staticClass: "mt-3 elevation-12 grey lighten-4" },
          [
            _c(
              "v-stepper",
              {
                attrs: { "non-linear": "", value: "1" },
                model: {
                  value: _vm.stepper,
                  callback: function($$v) {
                    _vm.stepper = $$v
                  },
                  expression: "stepper"
                }
              },
              [
                _c(
                  "v-stepper-header",
                  {},
                  [
                    _c(
                      "v-stepper-step",
                      {
                        attrs: {
                          rules: [
                            function() {
                              return _vm.generalErrors.length === 0
                            }
                          ],
                          editable: "",
                          step: 1
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("delegation.form.generalData")) +
                            " "
                        ),
                        _vm.generalErrors.length > 0
                          ? _c("small", [
                              _vm._v(
                                _vm._s(_vm.$t("global.fieldsToCheck")) +
                                  " " +
                                  _vm._s(_vm.generalErrors.length) +
                                  " "
                              )
                            ])
                          : _vm._e()
                      ]
                    ),
                    _c("v-divider"),
                    _c(
                      "v-stepper-step",
                      {
                        attrs: {
                          rules: [
                            function() {
                              return _vm.transportErrors.length === 0
                            }
                          ],
                          editable: "",
                          step: 2
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("delegation.form.transportData")) +
                            " "
                        ),
                        _vm.transportErrors.length > 0
                          ? _c("small", [
                              _vm._v(
                                _vm._s(_vm.$t("global.fieldsToCheck")) +
                                  " " +
                                  _vm._s(_vm.countTransportErrors) +
                                  " "
                              )
                            ])
                          : _vm._e()
                      ]
                    ),
                    _c("v-divider"),
                    _c(
                      "v-stepper-step",
                      {
                        attrs: {
                          rules: [
                            function() {
                              return _vm.countryErrors.length === 0
                            }
                          ],
                          editable: "",
                          step: 3
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("delegation.form.accommodationData")
                            ) +
                            " "
                        ),
                        _vm.countryErrors.length > 0
                          ? _c("small", [
                              _vm._v(
                                _vm._s(_vm.$t("global.fieldsToCheck")) +
                                  " " +
                                  _vm._s(_vm.countCountryErrors)
                              )
                            ])
                          : _vm._e()
                      ]
                    ),
                    _c("v-divider"),
                    _c(
                      "v-stepper-step",
                      {
                        attrs: {
                          rules: [
                            function() {
                              return _vm.summaryErrors.length === 0
                            }
                          ],
                          editable: "",
                          step: 4
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("delegation.form.summaryAttachment")
                            ) +
                            " "
                        ),
                        _vm.summaryErrors.length > 0
                          ? _c("small", [
                              _vm._v(
                                _vm._s(_vm.$t("global.fieldsToCheck")) +
                                  " " +
                                  _vm._s(_vm.summaryErrors.length) +
                                  " "
                              )
                            ])
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "v-stepper-items",
                  [
                    _c(
                      "v-stepper-content",
                      { attrs: { step: 1 } },
                      [
                        _vm.editedDelegation != null &&
                        _vm.errorsDelegation != null
                          ? _c("general", {
                              attrs: { delegationErrors: _vm.errorsDelegation }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "v-stepper-content",
                      { attrs: { step: 2 } },
                      [
                        _vm.editedDelegation != null &&
                        _vm.errorsDelegation != null
                          ? _c("transport", {
                              attrs: {
                                delegation: _vm.editedDelegation,
                                delegationErrors: _vm.errorsDelegation
                              },
                              on: {
                                "update:delegation": function($event) {
                                  _vm.editedDelegation = $event
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "v-stepper-content",
                      { attrs: { step: 3 } },
                      [
                        _vm.editedDelegation != null &&
                        _vm.errorsDelegation != null
                          ? _c("country", {
                              attrs: {
                                delegation: _vm.editedDelegation,
                                delegationErrors: _vm.errorsDelegation
                              },
                              on: {
                                "update:delegation": function($event) {
                                  _vm.editedDelegation = $event
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "v-stepper-content",
                      { attrs: { step: 4 } },
                      [
                        _vm.editedDelegation != null &&
                        _vm.errorsDelegation != null
                          ? _c("attachment", {
                              attrs: {
                                delegation: _vm.editedDelegation,
                                delegationErrors: _vm.errorsDelegation
                              },
                              on: {
                                "update:delegation": function($event) {
                                  _vm.editedDelegation = $event
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "v-card",
              [
                _c(
                  "v-card-actions",
                  [
                    _c("v-spacer"),
                    _vm.stepper === 1
                      ? _c(
                          "v-btn",
                          {
                            attrs: { color: "blue darken-1", text: "" },
                            nativeOn: {
                              click: function($event) {
                                return _vm.cancel()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                        )
                      : _vm._e(),
                    _vm.stepper > 1
                      ? _c(
                          "v-btn",
                          {
                            attrs: { color: "blue darken-1", text: "" },
                            nativeOn: {
                              click: function($event) {
                                _vm.stepper--
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("global.back")))]
                        )
                      : _vm._e(),
                    _vm.stepper < 4
                      ? _c(
                          "v-btn",
                          {
                            attrs: { color: "blue darken-1", text: "" },
                            nativeOn: {
                              click: function($event) {
                                _vm.stepper++
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("global.next")))]
                        )
                      : _vm._e(),
                    _vm.stepper === 4 &&
                    _vm.$store.state.Delegation.readonly !== true
                      ? _c(
                          "v-btn",
                          {
                            attrs: {
                              disabled: _vm.$store.getters["Ajax/loading"],
                              color: "blue darken-1",
                              text: ""
                            },
                            nativeOn: {
                              click: function($event) {
                                return _vm.save()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("global.save")))]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }